export function avatarModelForPlayer(player) {
  const name = String(player?.displayName || '').trim();

  return {
    src: player?.avatarUrl || '',
    alt: name || '玩家头像',
    fallbackLabel: name ? name.slice(0, 1).toUpperCase() : '?'
  };
}
